import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import './index.scss';
import './portal.css';
import reportWebVitals from './reportWebVitals';

// Get the root element
const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
